import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

// eslint-disable-next-line import/no-default-export,react/display-name
export default (props: IconProps) => (
  <IconBox viewBox="12 0 40 64" {...props}>
    <path d="M51.5 32L19.5 0L13 6.5L38.5 32L13 57.5L19.5 64L51.5 32Z" />
  </IconBox>
);
